import _ from 'lodash';

export const remove = (array, field, values) => {
  const result = array.map(
    elem => {
      if (!values.includes(elem[field])) {
        return elem;
      }
    }
  );

  // remove the nulls
  return _.compact(result);
};

export const merge = (array, field, newValue, values) => {
  return array.map(
    elem => {
      // deep copy
      let result = Object.assign({}, elem);
      values.map(
        v => {
          if (values.includes(elem[field])) {
            result[field] = newValue;
          }
        }
      );

      return result;
    }
  );
};

// map must be an object
export const rename = (array, field, map) => {
  return array.map(
    elem => {
      // deep copy
      let result = Object.assign({}, elem);
      const value = result[field];
      result[field] = map[value] || value;
      return result;
    }
  );
};

const filter = (array, field, options) => {
  let result = array;
  const keys = Object.keys(options);

  if (keys.includes('merge')) {
    result = merge(result, field, options.merge.newValue, options.merge.values);
  }

  if (keys.includes('remove')) {
    result = remove(result, field, options.remove.values);
  }

  if (keys.includes('rename')) {
    result = rename(result, field, options.rename.map);
  }

  return result;
};

export default filter;


// WEBPACK FOOTER //
// ./src/util/common/filter.js